var _style, _linearGradient, _path, _linearGradient2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKarura(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#path9_00000183207226421243246130000000649871513633350020_)}.st1{fill:url(#path11_00000111907511177103573740000007277726760468908191_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30.603,
    x2: 9.067,
    y1: 3.118,
    y2: 26.527,
    gradientTransform: "matrix(1 0 0 -1 0 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E40C5B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3B",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.1 2-8.6 7.8c-.9.8-2.1 1.3-3.3 1.3H7.6V2H3v26h2.5c1.4 0 2.7-.8 3.4-2 .5-.8.7-2.5.6-3.6-.1-2.5-.5-3.2-.5-3.2 0 1.8-1.8 1.9-1.8 1.9 1.3-1.2.6-2.2.6-2.2-2.3 1.6-2.9-.1-2.9-.3.1.1.7.6 2-1.1 1.3-1.8 3.1-4.8 4.2-5.6s2.2-.7 2.2-.7.6-.8 2.2-1.5 2.6.3 2.6.3c-1.6 1.3-3.9 3.5-4 6.6-.1 2.5 5.4 6.9 4.4 13.3.6-1.5.8-2.9.6-4.7-.2-1.5-1.1-4.5-1.1-4.5l5.2 7.2H29L17.7 12.4 29 2h-6.9z",
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 12.414,
    x2: 10.889,
    y1: 20.185,
    y2: 21.855,
    gradientTransform: "matrix(1 0 0 -1 0 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E40C5B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3B",
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 12.8c-.4.7-.4.9-.4.9s1.5-.2 1.9-2c-.1 0-1 .3-1.5 1.1z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarura);
export default __webpack_public_path__ + "static/media/karura.0bf5aee4c43aaa67489224bedb70609b.svg";
export { ForwardRef as ReactComponent };